import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createParty, partyKeys } from '@/services/parties'
import type { CreatePartyInput } from '@/types'

export function useCreateParty() {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (input: CreatePartyInput) => createParty(input),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: partyKeys.byNation(data.nation_id) })
      queryClient.invalidateQueries({ queryKey: partyKeys.myParties() })
      queryClient.invalidateQueries({ queryKey: partyKeys.myPartyInNation(data.nation_id) })
      queryClient.invalidateQueries({ queryKey: partyKeys.canCreate(data.nation_id) })
    },
  })

  return {
    createParty: mutation.mutate,
    createPartyAsync: mutation.mutateAsync,
    isCreating: mutation.isPending,
    error: mutation.error,
  }
}
